import React from "react";
import Chips from "../../Chips";
import Tooltip from "../../Tooltip";

import { assetImg } from "@/modules/moduleImporter";

import "./index.scss";
import { IGameTableType } from "@/types/GlobalTypes";
import nary from "@/modules/nary";

export default class M7 extends React.PureComponent<IGameTableType> {
	render() {
		//Template constant
		const { langdata } = this.props;

		const win = this.props.win || "";
		const winsplit = win.split(",");
		const winC = {};

		let anyTriple = false;
		winsplit.forEach(item => {
			if (!winC[item])
				winC[item] = 0;

			winC[item] += 1;

			if (winC[item] === 3)
				anyTriple = true;
		});

		//Bottom row
		const bottomRowLabels = [
			langdata["txt_shrimp"],
			langdata["txt_chicken"],
			langdata["txt_jug"],
			langdata["txt_coin"],
			langdata["txt_crab"],
			langdata["txt_fish"]
		];
		// langdata["txt_bet_translate_m7"];

		const bottomBetType = [
			"1:1 " + langdata["txt_on_one_dice"],
			"1:2 " + langdata["txt_on_two_dice"],
			"1:3 " + langdata["txt_on_three_dice"],
		];

		// Template constants
		const commonChipProps = {
			mobile: this.props.mobile,
			chipBase: this.props.chipBase,
			bets: this.props.bets,
			betOutOfBounds: this.props.betOutOfBounds
		};

		const commonTooltipProps = {
			langStr: langdata.language_code
		};

		return (
			this.props.portrait ?
				<div className="sl-table m7-portrait">
					<div className="row">
						{
							nary(3).map((num, idx) =>
								<div className="col-xs-4 m7-top-bet-types sl-green-old"
									key={"m7_portrait_top_" + idx}>
									<div className="bet-type">{bottomBetType[idx]}</div>
								</div>
							)
						}
					</div>

					<div className="row">
						{
							nary(6).map((num, idx) => {
								const group = `n`;
								const betKey = `${num}+${group}`;

								return (
									<div className={"sl-bet col-xs-2 m7-top m7-main-bets sl-green-old" + (winsplit.indexOf(num + "") >= 0 ? " sl-yellow-alternating" : "")}
										key={"m7_portrait_n_" + idx}
										{...{
											bet: num,
											pcode: this.props.pcode,
											group: group
										}}
										onClick={this.props.insertBet}>
										{assetImg("m7", num + "")}
										<Chips {...commonChipProps} betKey={betKey} />
									</div>
								);
							})
						}
					</div>

					<div className="row">
						{
							nary(6).map(num => {
								const betKey = num + "," + num;

								return <div className={"sl-bet col-xs-4 m7-stacks sl-green-old" + (winC[num] === 2 ? " sl-yellow-alternating" : "")}
									key={"m7_portrait_d_" + num}
									{...{
										bet: betKey, 
										pcode: this.props.pcode, 
										group: "d" 
									}}
									onClick={this.props.insertBet}>
									{assetImg("m7", num + "")}
									{assetImg("m7", num + "")}
									<div className="bet-type">1:8</div>
									<Chips {...commonChipProps} betKey={betKey + "+d"} />
								</div>;
							})
						}
					</div>

					<div className="row">
						{
							nary(6).map(num => {
								const betKey = num + "," + num + "," + num;
								return <div className={"sl-bet col-xs-4 m7-stacks sl-green-old" + (win === betKey ? " sl-yellow-alternating" : "")}
									key={"m7_portrait_t_" + num}
									{...{
										bet: betKey, 
										pcode: this.props.pcode, 
										group: "t" 
									}}
									onClick={this.props.insertBet}>
									{assetImg("m7", num + "")}
									{assetImg("m7", num + "")}
									{assetImg("m7", num + "")}
									<div className="bet-type">1:180</div>
									<Chips {...commonChipProps} betKey={betKey + "+t"} />
								</div>;
							})
						}
					</div>

					<div className="row">
						<div className={"sl-bet col-xs-12 sl-green-old" + (anyTriple ? " sl-yellow-alternating" : "")}
							{...{
								bet: "anytriple",
								pcode: this.props.pcode,
								group: "triple"
							}}
							onClick={this.props.insertBet}>
							{langdata["txt_any_triple"]}
							{/* Any Triple */}
							<div className="bet-type">1:30</div>
							<Chips {...commonChipProps} betKey="anytriple+triple" />
						</div>
					</div>


					{
						["1,2", "1,3", "1,4", "1,5", "1,6", "2,3", "2,4", "2,5", "2,6", "3,4", "3,5", "3,6", "4,5", "4,6", "5,6"].map((item, idx) => {
							const splitt = item.split(",");
							return <div className={"sl-bet col-20p m7-tall sl-green-old" + (winsplit.indexOf(splitt[0]) >= 0 && winsplit.indexOf(splitt[1]) >= 0 ? " sl-yellow-alternating" : "")}
								key={"m7_portrait_c_" + idx}
								{...{
									bet: item,
									pcode: this.props.pcode,
									group: "c"
								}}
								onClick={this.props.insertBet}>

								{assetImg("m7", splitt[0])}
								{assetImg("m7", splitt[1])}
								<div className="bet-type">1:5</div>
								<Chips {...commonChipProps} betKey={item + "+c"} />
							</div>;
						})
					}

					{
						["1,2,3,4", "2,4,5,6", "3,4,5,6", "4,2,3,5"].map((group, idx) => {
							const splitt = group.split(",");
							return <div className={"sl-bet col-xs-3 m7-group-bottom sl-green-old" + (winsplit.indexOf(splitt[0]) >= 0 && winsplit.indexOf(splitt[1]) >= 0 && winsplit.indexOf(splitt[2]) >= 0 ? " sl-yellow-alternating" : "")}
								key={"m7_portarit_e_" + idx}
								{...{
									bet: group,
									pcode: this.props.pcode,
									group: "e"
								}}

								onClick={this.props.insertBet}>

								{
									group.split(",").map(num =>
										assetImg("m7", num + "")
									)
								}
								<div className="bet-type">1:7</div>
								<Chips {...commonChipProps} betKey={group + "+e"} />
							</div>;
						})
					}

				</div>


				: <div className="sl-table table-m7">
					<div className="top">
						<div className="_2_3 sl-green-old">
							{
								nary(3).map(num => {
									const betKey = num + "," + num;
									return (
										<div key={"_2_3" + betKey}
											className={"sl-bet" + (winC[num] === 2 ? " sl-yellow-alternating" : "")}
											{...{
												bet: betKey,
												pcode: this.props.pcode,
												group: "d"
											}}
											onClick={this.props.insertBet}>
											{assetImg("m7", num + "", "m7_2_3_" + num + "_0")}
											{assetImg("m7", num + "", "m7_2_3_" + num + "_1")}
											<Chips between={true} {...commonChipProps} betKey={betKey + "+d"} />
											<Tooltip {...commonTooltipProps} bet={this.props.bets[betKey + "+d"]} />
										</div>
									);
								})
							}
							<div className="bet-type">1:8</div>
						</div>

						<div className="_3_3 sl-green-old">
							{
								nary(3).map(num => {
									const betKey = num + "," + num + "," + num;
									return (
										<div key={"_3_3" + betKey}
											className={"sl-bet" + (win === betKey ? " sl-yellow-alternating" : "")}
											{...{
												bet: betKey,
												pcode: this.props.pcode,
												group: "t"
											}}
											onClick={this.props.insertBet}>
											{assetImg("m7", num + "", "m7_3_3_" + num + "_0")}
											{assetImg("m7", num + "", "m7_3_3_" + num + "_1")}
											{assetImg("m7", num + "", "m7_3_3_" + num + "_2")}
											<Chips between={true} {...commonChipProps} betKey={betKey + "+t"} />
											<Tooltip {...commonTooltipProps} bet={this.props.bets[betKey + "+t"]} />
										</div>
									);
								})
							}
							<div className="bet-type">1:180</div>
						</div>
						<div className="sl-green-old">
							<div className={"sl-bet" + (anyTriple ? " sl-yellow-alternating" : "")}
								{...{
									bet: "anytriple",
									pcode: this.props.pcode,
									group: "triple"
								}}
								onClick={this.props.insertBet}>
								<div>{langdata["txt_any_triple"]}</div>

								<div className="bet-type">1:30</div>
								<Chips {...commonChipProps} betKey="anytriple+triple" />
								<Tooltip {...commonTooltipProps} bet={this.props.bets["anytriple+triple"]} />
							</div>
						</div>
						<div className="_3_3 sl-green-old">
							{
								[4, 5, 6].map(num => {
									const betKey = num + "," + num + "," + num;
									return (
										<div key={"_3_3" + betKey}
											className={"sl-bet" + (win === betKey ? " sl-yellow-alternating" : "")}
											{...{
												bet: betKey,
												pcode: this.props.pcode,
												group: "t"
											}}
											onClick={this.props.insertBet}>
											{assetImg("m7", num + "", "m7_3_3_" + num + "_0")}
											{assetImg("m7", num + "", "m7_3_3_" + num + "_1")}
											{assetImg("m7", num + "", "m7_3_3_" + num + "_2")}
											<Chips between={true} {...commonChipProps} betKey={betKey + "+t"} />
											<Tooltip {...commonTooltipProps} bet={this.props.bets[betKey + "+t"]} />
										</div>
									);
								})
							}
							<div className="bet-type">1:180</div>
						</div>
						<div className="_2_3 sl-green-old">
							{
								[4, 5, 6].map(num => {
									const betKey = num + "," + num;
									return (
										<div key={"_2_3" + betKey}
											className={"sl-bet" + (winC[num] === 2 ? " sl-yellow-alternating" : "")}
											{...{
												bet: betKey,
												pcode: this.props.pcode,
												group: "d"
											}}

											onClick={this.props.insertBet}>


											{assetImg("m7", num + "", "m7_2_3_" + num + "_0")}
											{assetImg("m7", num + "", "m7_2_3_" + num + "_1")}
											<Chips between={true} {...commonChipProps} betKey={betKey + "+d"} />
											<Tooltip {...commonTooltipProps} bet={this.props.bets[betKey + "+d"]} />
										</div>
									);
								})
							}
							<div className="bet-type">1:8</div>
						</div>
					</div>

					<div className="middle-long">
						{
							["1,2,3,4", "2,4,5,6", "3,4,5,6", "4,2,3,5"].map(item => {
								const splitt = item.split(",");
								return (
									<div key={"middle_long_" + item}
										className={"sl-bet sl-green-old" + (winsplit.indexOf(splitt[0]) >= 0 && winsplit.indexOf(splitt[1]) >= 0 && winsplit.indexOf(splitt[2]) >= 0 ? " sl-yellow-alternating" : "")}
										{...{
											bet: item,
											pcode: this.props.pcode,
											group: "e"
										}}
										onClick={this.props.insertBet}>
										{
											splitt.map((num, numIdx) =>
												assetImg("m7", splitt[numIdx] + "", "m7_ml_" + item + "_" + numIdx)
											)
										}
										<div className="bet-type">1:7</div>
										<Chips {...commonChipProps} betKey={item + "+e"} />
										<Tooltip {...commonTooltipProps} bet={this.props.bets[item + "+e"]} />
									</div>
								);
							})
						}
					</div>

					<div className="middle-short">
						{
							["1,2", "1,3", "1,4", "1,5", "1,6", "2,3", "2,4", "2,5", "2,6", "3,4", "3,5", "3,6", "4,5", "4,6", "5,6"].map((item, idx) => {
								const splitt = item.split(",");
								return (
									<div key={"middle_short_" + item}
										className={"sl-bet sl-green-old" + (winsplit.indexOf(splitt[0]) >= 0 && winsplit.indexOf(splitt[1]) >= 0 ? " sl-yellow-alternating" : "")}
										{...{
											bet: item,
											pcode: this.props.pcode,
											group: "c"
										}}
										onClick={this.props.insertBet}>
										{assetImg("m7", splitt[0], "m7_ms_" + item + "0")}<br />
										{assetImg("m7", splitt[1], "m7_ms_" + item + "1")}
										{(item === "1,2" || item === "2,5" || item === "5,6") &&
											<div className="bet-type">1:5</div> }
										<Chips {...commonChipProps} betKey={item + "+c"} />
										<Tooltip {...commonTooltipProps} bet={this.props.bets[item + "+c"]} />
									</div>
								);
							})
						}
					</div>

					<div className="bottom">
						{
							nary(6).map((num, idx) => {
								// const group = `n${Math.floor(idx / 2) + 1}`;
								const group = `n`;
								const betKey = `${num}+${group}`;

								return (
									<div key={"bottom_" + betKey}
										className={"sl-bet sl-green-old" + (winsplit.indexOf(num + "") >= 0 ? " sl-yellow-alternating" : "")}
										{...{
											bet: num,
											pcode: this.props.pcode,
											group: group
										}}
										onClick={this.props.insertBet}>
										{this.props.maximised &&
											<div>
												{bottomRowLabels[idx]}
											</div>
										}
										{assetImg("m7", num + "", "m7_b_" + idx)}
										<Chips between={true} {...commonChipProps} betKey={betKey} />
										<Tooltip {...commonTooltipProps} bet={this.props.bets[betKey]} />
									</div>
								);
							})
						}
					</div>

					<div className="bottom-text">
						{
							nary(3).map((num, idx) => (
								<div key={"bottom_text_" + idx}
									className="sl-green-old">
									<div className="bet-type">{bottomBetType[idx]}</div>
								</div>
							))
						}
					</div>
				</div>
		);
	}
}
